import { redirectToExternalAuth } from './amplify-service';
import { useEffect, type ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from './NewAuthProvider';
import Loader from 'components/technical/Loader/Loader';

const AutoSigninPage = (): ReactElement | null => {
  const { initialized, user, hasAnyAppAccess } = useAuth();

  useEffect(() => {
    if (initialized && !user) {
      redirectToExternalAuth();
    }
  }, [initialized, user]);

  if (!initialized) {
    return <Loader />;
  }

  if (hasAnyAppAccess()) {
    return <Navigate to="/" replace />;
  }

  return null;
};

export default AutoSigninPage;
